/**
 * True when the backend resolved at least one code system for the user. The
 * resolved list includes admin overrides, so it decides coding access.
 */
export const hasResolvedCodeSystems = (
  user: { enabled_code_systems?: readonly unknown[] | null } | null | undefined
): boolean => (user?.enabled_code_systems?.length ?? 0) > 0;
